import { CUSTOMER_TYPE } from '@klareospace/pharos-lib-types';
import type { Customer } from '@klareospace/pharos-lib-types';
import { getFullName } from '@klareospace/pharos-lib-utils';

/** Company name for company-type customers, else "firstName lastName". */
export function getCustomerDisplayName(customer: Customer): string {
  if (customer.type === CUSTOMER_TYPE.COMPANY && customer.companyName) return customer.companyName;
  return getFullName(customer.firstName, customer.lastName);
}
